import type { XlsxSelectionContext } from "@silurus/ooxml/xlsx";

export function spreadsheetCellPreview(context: XlsxSelectionContext | null) {
  if (context?.kind !== "range") return null;
  const { row, col } = context.selection.activeCell;
  let column = "";
  for (let index = col; index > 0; index = Math.floor((index - 1) / 26)) {
    column = String.fromCharCode(65 + ((index - 1) % 26)) + column;
  }
  const cell = context.cells.find(
    (cell) => cell.address.row === row && cell.address.col === col
  );
  const incomplete =
    context.truncationReasons.includes("text") || (!cell && context.truncated);
  return {
    address: `${column}${row}`,
    value: incomplete
      ? null
      : cell?.formula !== undefined
        ? `=${cell.formula.replace(/^=/, "")}`
        : (cell?.displayText ?? ""),
  };
}
